import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BankruptcySearchForm from '../../forms/bankruptcySearchForm/BankruptcySearchForm';
import CivilSearchFrom from '../../forms/civilSearchForm/CivilSearchForm';
import CriminalSearchForm from '../../forms/criminalSearchForm/CriminalSearchForm';
import SearchTypes from '../../FormElements/searchTypeRadioButtons/SearchTypes';
import SearchResults from '../../SearchResults';
import Loading from '../../../common/Loading';
import AppellateForm from '../../forms/AppellateForm';
import { isCourtDrive } from '../../../../util/globalUtils';
import * as actions from '../../../../redux/actions/pacerSearch';


const courtDriveSearchForms = {
  Bankruptcy: BankruptcySearchForm,
  Civil: CivilSearchFrom,
  Criminal: CriminalSearchForm,
  Appellate: AppellateForm,
};
const inforuptcySearchForms = {
  Bankruptcy: BankruptcySearchForm,
};

const searchForms = isCourtDrive() ? courtDriveSearchForms : inforuptcySearchForms;

class PacerSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // it's possible for user to set 'Civil' on courtdrive and then go to Inforuptcy where that form doesn't exist
      // this ensures that we dont' throw errors in such cases (
      // mostly admin might do this, regular users don't hop between sites)
      selectedSearchType: isCourtDrive()
        ? props.user.getIn(['settings', 'pacer_search_default_case_type'], 'Bankruptcy')
        : props.filters.get('case_type', 'Bankruptcy'),
    };
  }

  componentWillReceiveProps(nextProps) {
    const selectedSearchType = nextProps.filters.get('case_type', 'Bankruptcy');
    if (selectedSearchType !== this.state.selectedSearchType) {
      this.setState({ selectedSearchType });
    }
  }

  changeSearchType = (caseType) => {
    this.props.actions.resetSearchResults();
    this.props.actions.updateFilter({ case_type: caseType });
  };

  resetFilters = () => {
    this.props.actions.resetFilters();
  };

  render() {
    const { selectedSearchType } = this.state;
    const SearchForm = searchForms[selectedSearchType];
    const searchResultsType = this.props.pacerSearchResults.get('searchResultsType');

    const results = (searchResultsType != null)
      ? <SearchResults
          {...this.props}
          selectedSearchType={selectedSearchType}
          clickPage={this.clickPage}
          filters={this.props.filters} />
      : null;

    const searchTypes = Object.keys(searchForms);

    return (
      <div className="pacer-search-container">

        <div className="filings-form">

          <SearchTypes
            listOfSearchTypes={searchTypes}
            changeSearchType={this.changeSearchType}
            selectedSearchType={selectedSearchType} />

          <SearchForm
            {...this.props}
            searchType={selectedSearchType}
            filters={this.props.filters}
            updateFilter={this.props.actions.updateFilter}
            resetFilters={this.resetFilters} />

          <Loading show={this.props.pacerSearchResults.get('isLoading')} />
          {results}

        </div>
      </div>
    );
  }
}

PacerSearch.propTypes = {
  // will fix these types later
  user: PropTypes.any.isRequired,
  filters: PropTypes.any.isRequired,
  actions: PropTypes.object.isRequired,
  pacerSearchResults: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    pacerSearchResults: state.get('pacerSearchResults'),
    filters: state.get('pacerSearchResults').get('filters'),
    user: state.get('user'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PacerSearch);



// WEBPACK FOOTER //
// ./src/components/search/sections/pacerSearch/PacerSearch.jsx